import { render } from "./TransactionLimit.vue?vue&type=template&id=f03e5018&scoped=true&ts=true"
import script from "./TransactionLimit.vue?vue&type=script&lang=ts"
export * from "./TransactionLimit.vue?vue&type=script&lang=ts"

import "./TransactionLimit.vue?vue&type=style&index=0&id=f03e5018&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03e5018"],['__file',"src/components/general/TransactionLimit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f03e5018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f03e5018', __exports__)) {
    api.reload('f03e5018', __exports__)
  }
  
  module.hot.accept("./TransactionLimit.vue?vue&type=template&id=f03e5018&scoped=true&ts=true", () => {
    api.rerender('f03e5018', render)
  })

}


export default __exports__